import AgencySaleAddOrderView from 'features/Agency/components/AgencySaleAddOrderView';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import useRouter from 'hooks/useRouter';
import PropTypes from 'prop-types';

AgencySaleAddOrderScreen.propTypes = {
  removeBaseLayout: PropTypes.bool,
};

AgencySaleAddOrderScreen.defaultProps = {
  removeBaseLayout: false,
};

function AgencySaleAddOrderScreen(props) {
  // MARK: ---- PROPERTIES ----
  const { removeBaseLayout } = props;
  const router = useRouter();
  const { sale, investor, group, landlord, chargepoint, coinvestor } = router.query;
  console.log('coinvestor: ', coinvestor);
  return removeBaseLayout ? (
    <div style={{ minHeight: '1000px' }}>
      <AgencySaleAddOrderView
        initialAgencySaleId={sale}
        initialAgencyInvestorId={investor}
        initialAgencyGroupId={group}
        initialAgencyLandlordId={landlord}
        initialAgencyChargePointId={chargepoint}
        initialAgencyCoinvestorId={coinvestor}
      // removePadding={true}
      />
    </div>
  ) : (
    <KT01BaseLayout isFullScreen={true}>
      <div style={{ minHeight: '1000px' }}>
        <AgencySaleAddOrderView
          initialAgencySaleId={sale}
          initialAgencyInvestorId={investor}
          initialAgencyGroupId={group}
          initialAgencyLandlordId={landlord}
          initialAgencyChargePointId={chargepoint}
          initialAgencyCoinvestorId={coinvestor}
        />
      </div>
    </KT01BaseLayout>
  );
}

export default AgencySaleAddOrderScreen;
